import { BaseDetailSettings, DetailType } from 'kendo-angular-extensions';
import {
  FspParcelDetailsAttributeDto
} from '../free-services-parcel-request-grid/fsp-parcel-request-grid/free-services-parcel-request-grid-data-model';

export class FreeServicesParcelDetails {
  static fromApiToApp(
    dto: FspParcelDetailsAttributeDto,
  ): BaseDetailSettings[] {
    return [
      {
        title: 'FREE_PORTAL_SERVICES.ID',
        value: dto?.Identyfikator,
        type: DetailType.Text,
      },
      {
        title: 'FREE_PORTAL_SERVICES.NR_KW',
        value: dto?.NrKw,
        type: DetailType.Text,
      },
      {
        title: 'FREE_PORTAL_SERVICES.EWID_AREA',
        value: dto?.PowierzchniaEwidText,
        type: DetailType.Text,
      },
      {
        title: 'FREE_PORTAL_SERVICES.DISTRICT_NAME',
        value: dto?.ObrebNazwa,
        type: DetailType.Text,
      },
      {
        title: 'FREE_PORTAL_SERVICES.REGISTRY_UNIT',
        value: dto?.JednostkaRejestrowaNazwa,
        type: DetailType.Text,
      },
    ];
  }
}
